<template>
  <div class="header-container">
    <div class="header-main">
      <div class="header-left">
        <span v-if="userName">欢迎 {{ userName }} 来到{{ mallName }}，</span>
        <span v-else>欢迎来到{{ mallName }}，</span>
        <span v-if="userName" class="login" @click="loginout">退出</span>
        <span v-else class="login" @click="loginin">请登录</span>
      </div>
      <div class="header-right">
        <ul class="list">
          <li v-if="router!=='homepage'" class="list-child" @click="goHome()">商城首页</li>
          <li v-if="router!=='personal'" class="list-child" @click="toNewPage('/personal')">个人中心</li>
          <li class="list-child" @click="toNewPage('/personal/personal-menu/xb-order')">我的订单</li>
          <li class="list-child" @click="toNewPage('/personal/personal-menu/xb-shopping-cart')">购物车</li>
          <li class="list-child cusservice">
            <span>在线客服</span>
            <div class="cusservice-content">
              <div
                class="cusservice-content-child"
                v-for="(value,index) in cusservice"
                :key="index"
              >
                <p class="title">
                  <svg class="icon" v-if="value.name === '电话'">
                    <use xlink:href="#icon-电话" />
                  </svg>
                  <svg class="icon" v-if="value.name === 'QQ'">
                    <use xlink:href="#icon-QQ" />
                  </svg>
                  <svg class="icon" v-if="value.name === '旺旺'">
                    <use xlink:href="#icon-旺旺" />
                  </svg>
                  {{ value.name }}
                </p>
                <div class="cusservice-content-list" v-for="(v,i) in value.children" :key="i">
                  <a
                    v-if="value.name === 'QQ'"
                    :href="`http://wpa.qq.com/msgrd?v=3&uin=${v.content}&site=qq&menu=yes`"
                    target="_blank"
                    title="点击发送消息"
                  >
                    <img border="0" :src="`http://wpa.qq.com/pa?p=2:${v.content}:52`" alt />
                    <span class="desc">{{v.name}}</span>
                  </a>
                  <span class="desc" v-if="value.name !== 'QQ'">{{v.name}}：{{ v.content }}</span>
                </div>
              </div>
            </div>
          </li>
          <li class="list-child code" v-if="phoneUrl">
            <span>手机商城</span>
            <div id="qrcode" ref="qrcode"></div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getToken,
  deleteToken,
  removeXBPron,
  getXBBasicInformation,
  getXBGuestSetting,
  getXBUserName,
  removeXBUserName,
  saveXBCusservice,
  getXBCusservice
} from "common/js/storage";
import QRCode from "qrcodejs2";
import XBUser from "models/xb/user.js";
import XBHome from "models/xb/home.js";
const xbHome = new XBHome();
const xbUser = new XBUser();
export default {
  inject: ['reload'],
  data() {
    return {
      userName: "",
      phoneUrl: "",
      mallName: "",
      cusservice: [],
      router: ""
    };
  },
  beforeMount() {
    this.router = this.$route.matched[1].name;
    this.basicInformation();
    this.getUserName();
    this.getCusservice();
  },
  mounted() {
    if (this.phoneUrl) {
      this.$nextTick(() => {
        this.qrcode();
      });
    }
  },
  methods: {
    goHome() {
      this.$router.push("/homepage");
    },
    toNewPage(router) {
      let token = getToken() ? getToken() : "";
      if (token) {
        this.$router.push(router);
      } else {
        this.$router.push("/user-login");
      }
    },
    // 获取用户名
    getUserName() {
      if (getXBUserName() === "") {
        setTimeout(() => {
          this.userName = getXBUserName();
        }, 800);
      } else {
        this.userName = getXBUserName();
      }
    },
    // 获取客服数据
    getCusservice() {
      if (getXBCusservice() === "") {
        xbHome.getXBCusservice().then(res => {
          let arr = [];
          if (res.result.mobileList.length > 0) {
            let obj = {};
            obj.name = "电话";
            obj.children = [];
            res.result.mobileList.map(value => {
              let object = {};
              object.content = value.cusServiceContent;
              object.name = value.cusServiceName;
              obj.children.push(object);
            });
            arr.push(obj);
          }
          if (res.result.qqList.length > 0) {
            let obj = {};
            obj.name = "QQ";
            obj.children = [];
            res.result.qqList.map(value => {
              let object = {};
              object.content = value.cusServiceContent;
              object.name = value.cusServiceName;
              obj.children.push(object);
            });
            arr.push(obj);
          }
          if (res.result.wwList.length > 0) {
            let obj = {};
            obj.name = "旺旺";
            obj.children = [];
            res.result.wwList.map(value => {
              let object = {};
              object.content = value.cusServiceContent;
              object.name = value.cusServiceName;
              obj.children.push(object);
            });
            arr.push(obj);
          }
          this.cusservice = arr;
          saveXBCusservice(this.cusservice);
        });
      } else {
        this.cusservice = getXBCusservice();
      }
    },
    // 退出登录
    loginout() {
      xbUser.getXBLogout().then(res => {
        if (res.success) {
          deleteToken();
          removeXBPron()
          removeXBUserName();
          if (getXBGuestSetting().guestLogin !== 1) {
            this.$router.push("/user-login");
          } else {
            this.$router.push("/");
            this.getUserName()
            this.reload()
          }
        }
      });
    },
    loginin() {
      this.$router.push("/user-login");
    },
    // 获取基础信息
    basicInformation() {
      if (getXBBasicInformation() === "") {
        setTimeout(() => {
          let res = getXBBasicInformation();
          this.mallName = res.mallName;
          if (res.domainName) {
            this.phoneUrl = "http://" + res.domainName;
          }
        }, 800);
      } else {
        let res = getXBBasicInformation();
        this.mallName = res.mallName;
        if (res.domainName) {
          this.phoneUrl = "http://" + res.domainName;
        }
      }
    },
    qrcode() {
      let qrcode = new QRCode("qrcode", {
        width: 80, // 设置宽度，单位像素
        height: 80, // 设置高度，单位像素
        text: this.phoneUrl // 设置二维码内容或跳转地址
      });
      console.log(qrcode);
    }
  }
};
</script>
<style lang='scss' scoped>
.header-container {
  background: #f7f7f7;
  height: 40px;
  border-bottom: 1px solid #e4e4e4;
  .header-main {
    width: 1200px;
    margin: 0 auto;
    box-sizing: border-box;
    color: #606266;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
  }
  .header-left {
    .login {
      cursor: pointer;
    }
    .login:hover {
      color: #df3445;
    }
  }
  .header-right {
    height: 100%;
    .list {
      height: 100%;
      display: flex;
      align-items: center;
      .list-child {
        height: 100%;
        line-height: 40px;
        cursor: pointer;
        box-sizing: border-box;
        padding: 0 14px;
      }
      .cusservice {
        position: relative;
        .cusservice-content {
          display: none;
          position: absolute;
          border: 1px solid #e4e4e4;
          border-top: 0;
          cursor: default;
          z-index: 1000;
          background: #fff;
          width: 180px;
          left: -1px;
          top: 40px;
          box-sizing: border-box;
          padding: 0 12px 6px 12px;
          .cusservice-content-child {
            border-bottom: 1px solid #e4e4e4;
            display: flex;
            align-items: flex-start;
            flex-direction: column;
            padding-bottom: 4px;
            .title {
              line-height: 28px;
              display: flex;
              align-items: center;
              font-size: 12px;
              font-weight: 600;
              svg {
                width: 16px;
                height: 16px;
                margin-right: 5px;
              }
            }
            .cusservice-content-list {
              height: 26px;
              line-height: 26px;
              display: flex;
              align-items: center;
              span {
                line-height: 16px;
                font-size: 12px;
                color: #666666;
              }
              img {
                margin-right: 6px;
              }
            }
          }
          .cusservice-content-child:last-child {
            border-bottom: 0px;
          }
        }
      }
      .cusservice:hover {
        height: 40px;
        line-height: 40px;
        padding-top: 1px;
        padding: 0 13px;
        border-right: 1px solid rgba(228, 228, 228, 1);
        border-left: 1px solid rgba(228, 228, 228, 1);
        background: #fff;
        .cusservice-content {
          display: block;
        }
      }
      .code {
        position: relative;
        #qrcode {
          position: absolute;
          padding: 14px;
          border: 1px solid #e4e4e4;
          background: #fff;
          display: none;
          z-index: 100;
        }
      }
      .code:hover {
        #qrcode {
          display: block;
        }
      }
    }
  }
}
</style>
